import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { LoadingService } from '../../../../services/loading.service';
import { SnackService } from '../../../../services/snack.service';
import { ProperPageResult } from '../../../../model/proper-page-result';
import { SignPortalAssociation } from './sign-portal-association';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { StringHelper } from 'src/app/helpers/string-helper';
import { _get } from '../../../../services/base.service';
import { Observable } from 'rxjs';

export abstract class AbstractSignsPortalAssociationControllerRequestService {
  private readonly get: <T>(
    path: string,
    responseDeserializer: (response: any) => T
  ) => Observable<T>;

  private deserialize = (res: any): ProperPageResult<SignPortalAssociation> => {
    const result: ProperPageResult<SignPortalAssociation> =
      new ProperPageResult();
    result.totalItems = res.totalItems;
    result.items = res.items;
    if (CollectionHelper.isPopulated(result.items)) {
      result.items.forEach((a) => {
        a.companiesDisplay =
          a.sign != null &&
          CollectionHelper.isPopulated(a.sign.participatingCompanies)
            ? StringHelper.join(
                a.sign.participatingCompanies.map((pc) =>
                  pc.company != null &&
                  !StringHelper.isEmpty(pc.company.regularName)
                    ? pc.company.regularName
                    : null
                ),
                ', '
              )
            : null;
      });
    }
    return result;
  };
  protected constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router,
    controllerUrl: string
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get(controllerUrl, requestServices);
  }

  public getPaged(
    filters: string,
    sort: string,
    sortAscending: boolean,
    pageSize: number,
    page: number,
    showArchived: boolean
  ): Promise<ProperPageResult<SignPortalAssociation>> {
    const filtersParam = `filters=${filters}`;
    const pageableParam: string = `page=${page}&size=${pageSize}&sortDirection=${
      sortAscending ? 'ASC' : 'DESC'
    }&sortProperty=${sort}`;
    const showArchivedParam: string = `showArchived=${showArchived}`;
    const pathParams: string = `?${filtersParam}&${pageableParam}&${showArchivedParam}`;

    return this.get(pathParams, this.deserialize).toPromise();
  }
}
